<template>
    <Modal v-model="showCancel" title="取消课程" width="600">
        <h3 style="text-align: center;padding:15px;color:#ff2514">是否确认取消所选课程</h3>
        <Form :model="cancelForm" :label-width="100" ref="cancelForm"
              :rules="cancelFormValidate"
              @keyup.enter.native="cancelHandleSubmit()">
            <FormItem label="类型" prop="type" v-if="mode == 2">
                <Select v-model="cancelForm.type">
                    <Option :value="1">家长请假</Option>
                    <Option :value="2">后台操作</Option>
                </Select>
            </FormItem>
            <FormItem label="原因" prop="reason" >
                <Input v-model="cancelForm.reason" placeholder="" ></Input>
            </FormItem>
            <FormItem label="发送通知" prop="notify" >
                <RadioGroup v-model="cancelForm.notify">
                    <Radio :label="1" >发通知给家长</Radio>
                    <Radio :label="2" >不发通知给家长</Radio>
                </RadioGroup>
            </FormItem>

        </Form>
        <div slot="footer">
            <Button type="primary" size="large" @click="cancelHandleSubmit()" :loading="cancelForm.saving">
                确定取消
            </Button>
        </div>
    </Modal>
</template>
<script>
  export default {
    name: 'cancelWin',
    props: {
      mode: Number  //1 取消班级  2取消学员
    },
    data() {
      return {
        ids:null,
        showCancel:false,
        cancelForm:{
          notify:1,
          reason:null,
          type:null,
          saving:false
        },
        cancelFormValidate:{
          reason: [
            { required: true, message: '请输入取消原因', trigger: 'blur' }
          ],
          type: [
            { required: true, type:'number', message: '请选择类型', trigger: 'blur' }
          ],
        },

      }
    },
    methods: {
      cancelHandleSubmit(){
        if (!this.ids){
          this.$Message.error('请选择要取消课程');
          return;
        }
        let self = this;
        self.$refs['cancelForm'].validate((valid) => {
          try{
            if (valid) {
                self.cancelForm.saving = true;
                let api = self.$api.schedule.cancelOne;
                if (this.mode == 2){
                  api = self.$api.clazz.cancelStudentOne;
                }
                api({
                  ids:self.ids,
                  type:self.cancelForm.type,
                  reason:self.cancelForm.reason,
                  notify:self.cancelForm.notify}).then(resp=>{
                  if (resp.state == 'ok') {
                    self.$Message.success("取消成功");
                    self.showCancel = false;
                    self.$emit("on-cancel-success");
                  } else {
                    self.cancelForm.saving = false;
                    self.$Message.error(resp.msg);
                  }
                });
            } else {
              self.$Message.error('表单校验不通过');
            }
          }catch(err){
            console.log(err);
          }
        })
      },
      showCancelWin(ids){
        if (this.mode!= 1 && this.mode!= 2){
          this.$Message.error('取消模式未设置');
          return;
        }
        if (!ids){
          this.$Message.error('请选择要取消课程');
          return;
        }
        let type = null;
        if (this.mode == 1){
          type = 2;
        }
        this.cancelForm = {
          notify:1,
          reason:null,
          type:type,
          saving:false
        }
        this.ids = ids;
        this.showCancel = true;
      }
    }
  }
</script>
